import { AnalyticsSender } from '@funtech-int/yango-shared';

import { onboardingPlusShowed } from '@kinopoisk-int/evgen-web-events/web/onboarding_plus';

interface OnboardingAnalytics {
    showed: VoidFunction;
}

export function createOnboardingAnalytics(eventSender: AnalyticsSender): OnboardingAnalytics {
    return {
        showed() {
            eventSender.sendOnce(onboardingPlusShowed, {});
        },
    };
}
